module.exports = __webpack_public_path__ + "img/phone.0493ca28.png";